<template>
  <div class="template">
    <!-- <img class="top-picc-2" src="@/assets/images/template/picc-icon2.jpg" /> -->
    <div class="redline"></div>
    <div class="top-title">车辆差额保障服务函</div>
    <div class="num-con">
      编号：
      <span class="num">{{showDate.saleslip.pnum}}</span>
    </div>
    <table class="temTable" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <div class="p-content">
            兹证明
            <span class="key">“青岛鑫诚泰网络科技有限公司”</span>销售的
            <span class="key">“车辆差额保障”</span>服务函中双方约定的服务期限、服务范围、服务责任、赔偿处理、索赔材料的内容如下：
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">一.服务期限：</div>
          <div
            class="p-content"
          >自服务生效之日起{{swapper(selectYear)}}年有效。在服务期限内，如发生车辆转让，原保险责任立即中止。</div>
        </td>
      </tr>
      <tr>
        <td>
          <span class="key">二.承保区域：</span>中华人民共和国境内(不含港、澳、台)
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">三.保险责任：</div>
          <div class="p-content">
            保险期限内，被保障车辆在承保区域内被整车盗抢或车辆非人为原因整车自燃、整车碰撞全损或推断全损，车辆涉水，车主收到保险公司赔付后，免赔部分依法由被保险人承担经济赔偿责任。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">四.除外责任：</div>
          <div class="p-content">
            除产品责任保险条款中所列的除外责任外，保险人对下列各项亦不负责赔偿：1、非整车遭受盗窃，仅车上零部件或附属设备被盗窃、被破坏；2、被他人诈骗造成全车或部分损失；3、车辆因被有关国家机关罚没、扣押；4、因民事、经济纠纷造成车辆被抢劫、抢夺；5、租赁车辆；6、被保险人及其车主的故意行为；7、因违反本产品使用说明书规定的操作规程或擅自拆卸等引起的损失；8、非整车自燃，仅车上零部件或附属设备自燃；9、非整车撞损，仅车上零部件或附属设备撞损。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">五.赔偿处理：</div>
          <div class="p-content">
            被保障车辆在已购买车损险的情况下，发生保险事故并收到保险公司赔付后，被保险人可以得到以下赔偿：被保险机动车发生整车盗抢，非人为原因整车自燃，整车碰撞全损或推断全损，整车涉水本保障对保险公司免赔部分及车辆购置税在赔偿限额内进行赔偿；
          </div>
          <div class="p-content">
            赔付限额最高
            <span class="p-underline">{{showDate.saleslip.compensation*1.2}}</span>元。
          </div>
          <div class="p-content">
            特别声明：若安装该产品的车辆为金融机构贷款所购，未还清贷款时，同意优先向第一受益人:
            <span class="p-underline">{{showDate.saleslip.firstbeneficiaryname}}</span>，支付保险赔款。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">六.索赔材料：</div>1、购买本产品的凭证、交费凭证；2、被保险车辆的行驶证、车辆登记证、原始购车发票、购置税本、车辆购置税发票，原车的所有钥匙，每缺少一项，增加1%的免赔；3、机动车辆保险单、出险通知书、权益转让书；4、被保险车辆出险后保险公司理赔资料复印件及保险公司付款证明；5、保险人要求的其他相关材料。
        </td>
      </tr>
    </table>
    <div class="personal-title">车主信息</div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="130">车主姓名</td>
        <td colspan="2">{{showDate.saleslip.customername}}</td>
        <td width="130">证件号码</td>
        <td colspan="2">{{showDate.saleslip.certificatenum}}</td>
      </tr>
      <tr>
        <td>固定电话</td>
        <td colspan="2"></td>
        <td>移动电话</td>
        <td colspan="2">{{showDate.saleslip.phone}}</td>
      </tr>
      <tr>
        <td>联系地址</td>
        <td colspan="2">{{showDate.saleslip.address}}</td>
        <td>保费金额</td>
        <td colspan="2">{{showDate.saleslip.policyamount}}</td>
      </tr>
      <tr>
        <td>车牌号码</td>
        <td>{{showDate.saleslip.carnum}}</td>
        <td width="130">车架号</td>
        <td>{{showDate.saleslip.frame}}</td>
        <td width="130">车辆登记日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.buytime, 'yyyy-MM-dd')}}</td>
      </tr>
      <tr>
        <td>发动机号</td>
        <td>{{showDate.saleslip.enginenum}}</td>
        <td>产品编号</td>
        <td>{{showDate.saleslip.devicenum}}</td>
        <td>安装日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.installtime)}}</td>
      </tr>
      <tr>
        <td>安装地点</td>
        <td colspan="3">{{showDate.saleslip.installaddress}}</td>
        <td>安装人员</td>
        <td>{{showDate.saleslip.installman}}</td>
      </tr>
    </table>
    <p class="tips"></p>
    <p
      class="tips"
    >产品销售公司：(签章)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;车主签名：</p>
    <p class="tips">有效期:{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}</p>
    <p class="tips">全国统一客服热线：4006601517</p>
    <!-- <img class="inis2-3" src="@/assets/images/inis2-2.png" alt /> -->
    <img class="inis-1" src="@/assets/images/inis.png" alt />
  </div>
</template>

<script>
export default {
  props: ["showDate", "selectYear"],
  data() {
    return {};
  },
  mounted() {
    // this.ini ()
  },
  methods: {
    swapper(n) {
      switch (n) {
        case 1:
          return "壹";
        case 2:
          return "贰";
        case 3:
          return "叁";
        case 4:
          return "肆";
        case 5:
          return "伍";
      }
    },
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/template/s12.vue